import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { useCompanySession } from '../session';
import CompanyLayout from '../components/CompanyLayout';
import ClientPinBlock from '../components/ClientPinBlock';

function Customers() {
    const { session, loading } = useCompanySession();
    const [customers, setCustomers] = useState([]);
    const [ready, setReady] = useState(false);
    const [listOpen, setListOpen] = useState(true);
    const [openId, setOpenId] = useState(null);

    useEffect(() => {
        if (!session?.tenantId) return;
        const apply = (list) => {
            if (session.role === 'broker') {
                list = list.filter((c) => !c.brokerId || c.brokerId === session.uid);
            }
            setCustomers(list);
            setReady(true);
        };
        getDocs(query(collection(db, 'tenants', session.tenantId, 'customers'), orderBy('createdAt', 'desc'))).then((s) => {
            const list = [];
            s.forEach((d) => list.push({ id: d.id, ...d.data() }));
            apply(list);
        }).catch(() => {
            getDocs(collection(db, 'tenants', session.tenantId, 'customers')).then((s) => {
                const list = [];
                s.forEach((d) => list.push({ id: d.id, ...d.data() }));
                apply(list);
            });
        });
    }, [session]);

    if (loading || !session || !ready) return <div className="p-5">Loading customers...</div>;

    return (
        <CompanyLayout session={session}>
            <p className="text-muted small mb-3">Collapse the list to save space. Click a client to open their file.</p>
            <div className="bd-card" style={{ padding: 0, overflow: 'hidden' }}>
                <div className="bd-collapsible-header" onClick={() => setListOpen(!listOpen)} style={{ border: 'none', borderRadius: 0 }}>
                    <div className="bd-header-left">
                        <span>Clients</span>
                        <span className="bd-count-pill">{customers.length}</span>
                    </div>
                    <span className={'bd-arrow' + (listOpen ? ' open' : '')}>▼</span>
                </div>
                {listOpen && (
                    <div style={{ overflowX: 'auto' }}>
                        <table className="bd-table" style={{ margin: 0 }}>
                            <thead>
                                <tr>
                                    <th>Customer</th>
                                    <th>National ID</th>
                                    <th>Phone</th>
                                    <th>Occupation</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customers.map((c) => {
                                    const expanded = openId === c.id;
                                    return (
                                        <React.Fragment key={c.id}>
                                            <tr className="bd-row-click" onClick={() => setOpenId(expanded ? null : c.id)}>
                                                <td>{c.fullName}</td>
                                                <td>{c.nationalId}</td>
                                                <td>{c.phone}</td>
                                                <td>{c.occupation || '—'}</td>
                                            </tr>
                                            {expanded && (
                                                <tr className="bd-row-detail">
                                                    <td colSpan={4}>
                                                        <div className="bd-form-grid" style={{ padding: '4px 8px 12px' }}>
                                                            <div><strong>Address</strong><div>{c.address || '—'}</div></div>
                                                            <div><strong>Email</strong><div>{c.email || '—'}</div></div>
                                                            <div><strong>Lookup phone</strong><div>{c.phone}</div></div>
                                                            <ClientPinBlock
                                                                session={session}
                                                                customer={c}
                                                                onUpdated={(id, code) => setCustomers((prev) => prev.map((row) => row.id === id ? { ...row, lookupPin: code, pinIssued: true } : row))}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </CompanyLayout>
    );
}
export default Customers;
